import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

import React from "react";

import { ChevronDownIcon } from "@chakra-ui/icons";
import {
	Menu,
	MenuButton,
	IconButton,
	MenuList,
	MenuItem,
	Flex,
	Text,
	MenuDivider,
	Icon,
	MenuOptionGroup,
	Button,
} from "@chakra-ui/react";
import { es } from "date-fns/locale";
import { DateRange, Range } from "react-date-range";
import { BsSortDown, BsSortUpAlt } from "react-icons/bs";

import { ActivoCompletoOutput } from "components/Portfolio/types/activos";
import { PortfolioFilterSelection } from "components/Portfolio/types/filterData";
import { columnHeaderLabel } from "helpers/FiltersColumns";
import { actions as portfolioActions } from "store/portfolio/reducer";
import { useAppDispatch, useAppSelector } from "store/store";

type IProps = {
	column: keyof ActivoCompletoOutput;
};

export const FilterDropDownDate: React.FC<IProps> = (props) => {
	const { column } = props;
	const filterSelection = useAppSelector((state) => state.portfolio.filterSelection);
	const dispatch = useAppDispatch();

	const [order, setOrder] = React.useState<"asc" | "desc" | undefined>(undefined);

	const filterKey = columnToFilterMap[column];
	const [currFrom, currTo] =
		filterSelection && filterKey && Array.isArray(filterSelection[filterKey])
			? (filterSelection[filterKey] as string[])
			: [];

	const [innerCalendarState, setInnerCalendarState] = React.useState<Range[]>([
		{
			startDate: currFrom ? new Date(currFrom) : undefined,
			endDate: currTo ? new Date(currTo) : new Date(),
			key: "selection",
		},
	]);

	React.useEffect(() => {
		if (order !== undefined) {
			dispatch(portfolioActions.setOrderBy({ column: column, direction: order }));
		}
	}, [order]);

	const onCalendarSubmit = () => {
		const rangeValue = innerCalendarState[0];
		const rangeKey = columnToFilterMap[column];
		if (!rangeKey) return;
		const newFilterSelection = {
			...(filterSelection || {}),
			[rangeKey]: [rangeValue.startDate?.toISOString() ?? "", rangeValue.endDate?.toISOString() ?? ""],
		};
		dispatch(portfolioActions.setFilterSelection(newFilterSelection));
	};

	return (
		<Flex alignItems="center">
			<Menu closeOnSelect={false}>
				<MenuButton
					as={IconButton}
					aria-label="Filter"
					icon={<ChevronDownIcon color="gray.700" />}
					variant="solid"
					borderRadius="md"
					bgColor="white"
					size="1rem"
					p=".05rem"
					border="1px solid"
					borderColor="gray.200"
					ml=".5rem"
				/>
				<MenuList minWidth="240px">
					<MenuOptionGroup type="radio">
						<MenuItem _hover={{ bg: "gray.100" }} onClick={() => setOrder("desc")}>
							<Icon as={BsSortDown} fontSize="1rem" color="gray.500" mr=".75rem" />
							<Text textStyle="body3">Descendente</Text>
						</MenuItem>
						<MenuItem _hover={{ bg: "gray.100" }} onClick={() => setOrder("asc")}>
							<Icon as={BsSortUpAlt} fontSize="1rem" color="gray.500" mr=".75rem" />
							<Text textStyle="body3">Ascendente</Text>
						</MenuItem>
					</MenuOptionGroup>
					<MenuDivider w="90%" mx="auto" />
					<Flex flexDir="column">
						<DateRange
							rangeColors={["var(--chakra-colors-gray-400)"]}
							editableDateInputs={true}
							onChange={(it) => setInnerCalendarState([it.selection])}
							moveRangeOnFirstSelection={false}
							retainEndDateOnFirstSelection={true}
							ranges={innerCalendarState}
							locale={es}
						/>
						<Button
							m="0 1rem 0.5rem auto"
							size="lg"
							onClick={onCalendarSubmit}
							bg="gray.400"
							_hover={{ bgColor: "gray.500" }}
						>
							<Text textStyle="body3" color="white">
								Aplicar
							</Text>
						</Button>
					</Flex>
				</MenuList>
			</Menu>
			<Text title={columnHeaderLabel(column)} color="gray.500" textStyle="body3" pl=".5rem">
				{columnHeaderLabel(column)}
			</Text>
		</Flex>
	);
};

const columnToFilterMap: Partial<Record<keyof ActivoCompletoOutput, keyof PortfolioFilterSelection>> = {
	fecha_visita_programada: "fechaVisita",
	fecha_visita_programada_prox_ite: "fechaVisitaProxIte",
	comunicacion_ultima_actualizacion: "ultimaActualizacion",
};
